

























import { TasksUnassigned } from '@/shared/exception-reports/tasks-unassigned';
import { TaskType } from '@/shared/task-type';
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class TasksUnassignedTable extends Vue {
    @Prop({ required: true }) private tasks!: Array<TasksUnassigned>;
    @Prop({ required: true }) private emptyText!: string;

    private currentPage: number = 1;
    private pageSize: number = 50;

    private get fields(): Array<{}> {
        return [
            { key: 'type', label: 'Task Type' },
            { key: 'partnerPractice', label: 'Assigned To' },
            { key: 'accountNo', label: 'Account No' },
            { key: 'clientName', label: 'Client Name' },
            { key: 'dueDate', label: 'Due Date' },
        ];
    }

    private get totalRows(): number {
        return this.tasks.length;
    }

    private get paginationDescription(): string {
        const start: number = (this.tasks.length < 1) ? 0 : ((this.currentPage - 1) * this.pageSize) + 1;
        const end: number = start + this.pageSize > this.totalRows ? this.totalRows : start + this.pageSize - 1;

        return `Showing ${start.toLocaleString()} - ${end.toLocaleString()} of ${this.totalRows.toLocaleString()}`;
    }

    private get startDate(): string | Date | null {
        const dates = this.tasks.map((t) => t.dueDate)
            .sort((d1, d2) => {
                if (d1! > d2!) { return 1; }
                if (d1! < d2!) { return -1; }
                return 0;
            });

        return dates[0];
    }

    private get endDate(): string | Date | null {
        const dates = this.tasks.map((t) => t.dueDate)
            .sort((d1, d2) => {
                if (d1! < d2!) { return 1; }
                if (d1! > d2!) { return -1; }
                return 0;
            });

        return dates[0];
    }

    @Watch('tasks')
    private onTasksChanged(): void {
        this.currentPage = 1;
    }

    private taskTypeDescription(id: TaskType) {
        switch (id) {
            case TaskType.RetrieveWillPacket:
                return 'Retrieve Will Packet';
            case TaskType.SendConfirmationLetter:
                return 'Send Confirmation Letter';
            default:
                return '';
        }
    }

    private goToClient(clientId: string): void {
        window.open('../../clients/' + clientId, '_blank');
    }
}
